import {createAsyncThunk} from '@reduxjs/toolkit';
import {
	ILastClosedShift,
	IRestaraunt,
	IRestTotal,
	IRevenueRestaurantsData,
} from '../../../entities/rKeeper';
import {axiosErrorHandler} from '../../config';
import {
	getLastShiftRequest,
	getRestauransRequest,
	getRestTotalRequest,
	getRevenueRestaurantRequest,
	getRevenueWaitersRequest,
} from '../../services/rKeeperApi';
import {formatDatesInObject} from '../../../utils/functions/formatDatesInObject';
import {IDateQuery} from '../../../types';
import {IRestTotalReq} from '../../services/rKeeperApi/types';

export const getLastClosetShift = createAsyncThunk<ILastClosedShift, number>(
	'@@rKeeper/getLastClosetShift',
	async (shop_id: number, {rejectWithValue}) => {
		try {
			const {data} = await getLastShiftRequest(shop_id);
			const formatedData = formatDatesInObject<ILastClosedShift>(data);
			return formatedData;
		} catch (err) {
			return rejectWithValue(axiosErrorHandler(err));
		}
	},
);

export const getRevenueWaiters = createAsyncThunk<
	IRevenueRestaurantsData,
	{shop_id: number; params: IDateQuery}
>(
	'@@rKeeper/getRevenueWaiters',
	async ({shop_id, params}: {shop_id: number; params: IDateQuery}, {rejectWithValue}) => {
		try {
			const {data} = await getRevenueWaitersRequest(shop_id, params);
			return data;
		} catch (err) {
			return rejectWithValue(axiosErrorHandler(err));
		}
	},
);

export const getRevenueRestaurants = createAsyncThunk<
	IRevenueRestaurantsData,
	{shop_id: number; params: IDateQuery}
>(
	'@@rKeeper/getRevenueRestaurants',
	async ({shop_id, params}: {shop_id: number; params: IDateQuery}, {rejectWithValue}) => {
		try {
			const {data} = await getRevenueRestaurantRequest(shop_id, params);
			return data;
		} catch (err) {
			return rejectWithValue(axiosErrorHandler(err));
		}
	},
);
export const getRestaurants = createAsyncThunk<IRestaraunt[], number>(
	'@@rKeeper/getRestaurants',
	async (shop_id: number, {rejectWithValue}) => {
		try {
			const {data} = await getRestauransRequest(shop_id);
			return data;
		} catch (err) {
			return rejectWithValue(axiosErrorHandler(err));
		}
	},
);

export const getRestTotal = createAsyncThunk<IRestTotal, {shop_id: number; params: IRestTotalReq}>(
	'@@rKeeper/getRestTotal',
	async ({shop_id, params}: {shop_id: number; params: IRestTotalReq}, {rejectWithValue}) => {
		try {
			const {data} = await getRestTotalRequest(shop_id, params);
			return data;
		} catch (err) {
			return rejectWithValue(axiosErrorHandler(err));
		}
	},
);
